"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getPostDetails;
const client_1 = __importDefault(require("../../client/client"));
function getPostDetails(config, postId) {
    return client_1.default.get(config["API_URL"], "/postDetails/" + postId);
}
